<template>
	<Transition @leave="onLeave">
		<div
			v-if="visible"
			v-editable="blok"
			class="bg-background-secondary overflow-hidden"
		>
			<div class="container flex gap-4 py-2 md:gap-4 md:pb-5 md:pt-8 relative">
				<FeatherIcon
					v-if="blok.icon.icon"
					:icon="blok.icon.icon"
					class="w-6 h-6 text-icon-primary"
				/>
				<div class="typo-body-s mb-2">
					<h4
						class="typo-h4 mb-3"
						v-text="blok.title"
					/>
					<RichText
						class="rem:max-w-[775px] typo-body-m"
						:data="blok.text"
					/>
				</div>
				<div class="h-fit my-auto ml-auto flex flex-col items-end gap-4">
					<button
						type="button"
						class="z-10 w-6 h-6 relative"
						@click="setVisible(false)"
					>
						<NuxtIcon name="x" class="text-2xl md:text-3xl text-icon-primary absolute-center" />
					</button>
					<LinkBlock
						v-if="blok.ctaButton?.[0]"
						class="btn btn-primary btn-sm md:btn-lg lg:btn-xl"
						:blok="blok.ctaButton[0]"
						@click="setVisible(false)"
					/>
				</div>
			</div>
		</div>
	</Transition>
</template>

<script setup lang="ts">
	import {gsap} from 'gsap';
	import {storeToRefs} from 'pinia';
	import {useStoryblokHypermarketsStore} from '@/stores/storyblokHypermarkets';
	import {useInformationBarStore} from '@/stores/informationBar';
	import type {InformationBarStoryblok} from '@/storyblok/types';

	type Props = {
		blok: InformationBarStoryblok;
	};

	const props = defineProps<Props>();
	const {selectedHypermarketInstance} = storeToRefs(useStoryblokHypermarketsStore());
	const {visible} = storeToRefs(useInformationBarStore());
	const {setVisible} = useInformationBarStore();

	const informationBarHideTimeout = ref<NodeJS.Timeout>();

	onMounted(updateTimeout);
	watch(selectedHypermarketInstance, updateTimeout);

	function onLeave(el: Element, done: () => void) {
		gsap.to(el, {height: 0, onComplete: done});
	}

	function updateTimeout() {
		clearTimeout(informationBarHideTimeout.value);
		if (props.blok.optionToClose === 'timeout') {
			informationBarHideTimeout.value = setTimeout(() => {
				setVisible(false);
			}, 10000);
		}
	}
</script>
